let InteractiveInviteChestPreview = xClass("InteractiveInviteChestPreview")

let Status = {
    Hide: 0,
    Show: 1,
    Stable: 2,
}

InteractiveInviteChestPreview.prototype.ctor = function (node) {
    var self = this
    self.node = node

    self.init();

    self.duration = 0;
    self.status = Status.Hide;
    self.node.setVisible(false);

    self.timerId = null;
}
InteractiveInviteChestPreview.prototype.init = function () {
    var self = this
    self.node.setAnchorPoint(cc.p(0.5, 0));
}

/**
 * 显示，不关闭
 */
InteractiveInviteChestPreview.prototype.stable = function() {
    let self = this;

    if (self.status != Status.Stable) {
        self.status = Status.Stable;

        self.clearTimer();
        self.clearListener();

        self.duration = 0;
        self.node.stopAllActions();
        self.node.setVisible(true);
        self.node.setOpacity(255);
        self.node.setScale(1);
    }
}

/**
 * 显示
 * @param {*} duration 显示时长（秒）
 */
InteractiveInviteChestPreview.prototype.popup = function (duration) {
    var self = this    

    self.duration = duration || 3;
    if (self.status == Status.Show) {
        self.startTimer();
        return;
    }

    self.status = Status.Show

    self.node.stopAllActions();
    self.node.setVisible(true);
    self.node.setOpacity(255);
    self.node.setScale(0.1);
    self.node.runAction(cc.Sequence.create(
        cc.ScaleTo.create(0.1, 1.2), 
        cc.ScaleTo.create(0.05, 1), 
        cc.CallFunc.create(()=> self.startTimer())
    ));
    self.registerTouchEvents();
}

InteractiveInviteChestPreview.prototype.startTimer = function() {
    let self = this;
    self.clearTimer();
    this.timerId = cc.director.getScheduler().scheduleScriptFunc(()=> self.hide(), self.duration, false);
}

InteractiveInviteChestPreview.prototype.clearTimer = function() {
    let self = this;
    if (self.timerId != null) {
        cc.director.getScheduler().unscheduleScriptEntry(this.timerId);
        self.timerId = null;
    }
}

InteractiveInviteChestPreview.prototype.hide = function () {
    var self = this
    self.clearAll();

    if (self.status == Status.Hide)
        return;

    let lastStatus = self.status;
    self.status = Status.Hide;

    self.node.stopAllActions();
    if (lastStatus == Status.Show) {
        self.node.runAction(cc.Sequence.create(cc.Spawn.create(cc.ScaleTo.create(0.1, 0), cc.FadeOut.create(0.1)), cc.CallFunc.create(() => {
            self.node.setVisible(false);
        })));
    } else {
        self.node.setVisible(false);
    }
}
InteractiveInviteChestPreview.prototype.isTouchInBox = function (tp) {
    var self = this
    var size = self.node.getContentSize()
    var leftBottom = cc.p(0, 0)
    var rightUpper = cc.p(size.width, size.height)
    var lb = self.node.convertToWorldSpace(leftBottom)
    var ru = self.node.convertToWorldSpace(rightUpper)
    return tp.x > lb.x && tp.x < ru.x && tp.y > lb.y && tp.y < ru.y
}

InteractiveInviteChestPreview.prototype.onTouchOutside = function () {
    var self = this; 
    self.hide()
}

InteractiveInviteChestPreview.prototype.registerTouchEvents = function () {
    var self = this
    function onTouchBegan(touch, event) {
        var tp = touch.getLocation()
        if (self.isTouchInBox(tp)) {
            return true
        } else {
            self.onTouchOutside()
            return false
        }
    }
    var listener = cc.EventListenerTouchOneByOne.create();
    listener.registerScriptHandler(onTouchBegan, cc.Handler.EVENT_TOUCH_BEGAN)
    cc.eventManager.addListener(listener, self.node)
    self.listener = listener;
}

InteractiveInviteChestPreview.prototype.clearAll = function() {
    let self = this;
    self.clearListener();
    self.clearTimer();
}

InteractiveInviteChestPreview.prototype.clearListener = function() {
    let self = this
    if (self.listener) {
        cc.eventManager.removeListener(self.listener)
        self.listener = null;
    }
}
InteractiveInviteChestPreview.prototype.destroy = function() {
    let self = this;
    self.clearAll();

    if(self.node) {
        self.node.stopAllActions();
        self.node.setVisible(false);
        self.node = null;
    }
}

module.exports = InteractiveInviteChestPreview
